import {Component, OnInit} from '@angular/core';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {TranslatePipe} from '@ngx-translate/core';
import {MatFormField, MatFormFieldModule, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  DynamicConfirmationDialogComponent
} from '../../components/dynamic-confirmation-dialog/dynamic-confirmation-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from '../../services/dialog.service';
import {HttpClient} from '@angular/common/http';
import {SnackBarService} from '../../services/snackbar.service';
import {DocumentCollectionHal, DocumentHal} from '../../models/HAL/document-hal.model';
import {MatExpansionModule} from '@angular/material/expansion';
import {CaseHal} from '../../models/HAL/case-hal.model';
import {CaseCompletionDto} from '../../models/DTO/CaseCompletionDto';
import {SessionService} from '../../services/session.service';
import {LoadingSpinnerService} from '../../services/loading-spinner.service';

@Component({
  selector: 'app-case-completion',
  imports: [
    MatButton,
    TranslatePipe,
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    MatLabel,
    MatIcon,
    MatIconButton,
    MatFormFieldModule,
    FormsModule,
    MatExpansionModule
  ],
  templateUrl: './case-completion.component.html',
  styleUrl: './case-completion.component.scss'
})
export class CaseCompletionComponent implements OnInit {
  protected commentFormControl: FormControl = new FormControl();
  protected documents: DocumentHal[] = [];
  protected case: CaseHal;

  constructor(readonly activatedRoute: ActivatedRoute,
              private readonly snackBarService: SnackBarService,
              private readonly router: Router,
              private readonly httpClient: HttpClient,
              private readonly sessionService: SessionService,
              private readonly dialogService: DialogService,
              private readonly loadingSpinnerService: LoadingSpinnerService
  ) {
    this.case = new CaseHal(activatedRoute.snapshot.data['completeCase']);
  }

  ngOnInit(): void {
    const url = new URL(this.case._links.getLink('getDocuments')!.href);
    url.searchParams.set('paged', 'false');
    this.httpClient.get<DocumentCollectionHal>(url.href).subscribe({
      next: (response: DocumentCollectionHal) => {
        for (let document of response._embedded?.documents || []) {
          if (document.fileMetadata?.fileId) {
            this.documents.push(document);
          }
          if (!document.fileMetadata?.fileId && document.formIdentifier) {
            this.documents.push(document);
          }
          this.loadingSpinnerService.hide();
        }
      },
      error: () => {
        this.loadingSpinnerService.hide();
        this.snackBarService.open('completeCase.snackbar.loadError', 3, 'error');
      }
    });
  }

  protected backToCase(): void {
    const dialogRef = this.dialogService.open(DynamicConfirmationDialogComponent, {
      data: {
        title: 'completeCase.backToCaseModal.title',
        message: 'completeCase.backToCaseModal.message',
        confirmButtonText: 'completeCase.backToCaseModal.confirm',
        cancelButtonText: 'completeCase.backToCaseModal.cancel'
      }
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (!result) {
        this.loadingSpinnerService.show();
        this.router.navigate([this.case._links.getLink('case')?.getRoute()]).then();
      }
    });
  }

  protected async completeCase() {
    const dialogRef = this.dialogService.open(DynamicConfirmationDialogComponent, {
      data: {
        title: 'completeCase.sendRequestModal.title',
        message: 'completeCase.sendRequestModal.message',
        confirmButtonText: 'completeCase.sendRequestModal.confirm',
        cancelButtonText: 'completeCase.sendRequestModal.cancel'
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.loadingSpinnerService.show();
        this.sendCompleteCaseRequest();
      }
    });
  }

  private sendCompleteCaseRequest(): void {
    const caseCompletionDto = new CaseCompletionDto({
      personalMessage: this.commentFormControl.value
    });

    this.httpClient.post<CaseHal>(
      this.case._links.getLink('completeCase')!.href,
      caseCompletionDto
    ).subscribe({
      next: () => {
        this.snackBarService.open('completeCase.snackbar.requestSuccess', 3);
        this.router.navigate([this.sessionService.getSession().currentTeam!._links.getLink('caseOverview')?.getRoute()]).then();
      },
      error: () => {
        this.loadingSpinnerService.hide();
        this.snackBarService.open('completeCase.snackbar.requestError', 3, 'error');
      }
    });
  }

}
